import { requiredWithRegionOther } from './custom/solution';
import { isAllowAcceptTypeFile, isAllowMegaSizeFile, isFileValid, isNumber, isNumberWithinRange, isRequired, isRequiredText, isRequiredWithObj, strMax, } from './utils';
export const validateTitle = [
    isRequiredText('プロジェクト事例タイトルを入力してください'),
    strMax(25, 'プロジェクト事例タイトルは25文字以内で入力してください'),
];
export const validateSubTitle = [
    isRequiredText('プロジェクト事例サブタイトルを入力してください'),
    strMax(50, 'プロジェクト事例タイトルは50文字以内で入力してください'),
];
export const validateDescription = [
    isRequiredText('プロジェクト事例の概要を入力してください'),
    strMax(1000, 'プロジェクト事例の概要は1000文字以内で入力してください'),
];
export const validatePoint1 = [
    isRequiredText('1つめのポイントを入力してください'),
    strMax(49, '1つめのポイントは49文字以内で入力してください'),
];
export const validatePoint2 = [
    isRequiredText('2つめのポイントを入力してください'),
    strMax(49, '2つめのポイントは49文字以内で入力してください'),
];
export const validatePoint3 = [
    isRequiredText('3つめのポイントを入力してください'),
    strMax(49, '3つめのポイントは49文字以内で入力してください'),
];
export const validateMiddleClass = [
    isRequiredText('メインカテゴリーを入力してください'),
];
export const validateSubMiddleClasses = [
    (values) => (values || []).every((v) => !v)
        ? 'サブカテゴリーを1つ以上選択してください'
        : '',
    isRequiredText('サブカテゴリーを入力してください'),
];
export const validateTags = [
    (values) => (values || []).every((v) => !v) ? 'タグを1つ以上選択してください' : '',
    isRequiredText('タグを1つ以上選択してください'),
];
export const validateSolveIssue = [
    isRequiredText('プロジェクト事例の対象者を記載してください'),
    strMax(500, 'プロジェクト事例の対象者は500文字以内で入力してください。'),
];
export const validatePerformance = [
    isRequiredText('プロジェクト事例の実績を入力してください'),
    strMax(200, 'プロジェクト事例の実績は200文字以内で入力してください'),
];
export const validateOptionName = [
    isRequiredWithObj('オプションの項目を入力してください', 'price'),
    strMax(200, 'オプションの項目は200文字以内で入力してください'),
];
export const validateOptionPrice = [
    isRequiredWithObj('オプションの金額を入力してください', 'name'),
    isNumber('正の整数を入力してください'),
    isNumberWithinRange(0, 999, 'オプションの金額は999万円以下で入力してください'),
];
export const validatePrice = [
    isRequiredText('プロジェクト事例の金額を入力してください'),
    isNumber('正の整数を入力してください'),
    isNumberWithinRange(1, 9999, 'プロジェクト事例の金額は1万円から9999万円の間で入力してください'),
];
export const validateSolutionPdf = [
    (value, record) => {
        if (!record.pdfFileUrl) {
            return isRequired(value) ? 'ファイルを選択してください' : '';
        }
        return '';
    },
    isFileValid(),
    isAllowAcceptTypeFile('application/pdf', 'PDFファイルを選択してください'),
    isAllowMegaSizeFile(10, '10MB以下のファイルを選択してください'),
];
export const validateSolutionImage = [
    (value, record) => {
        if (!record.thumbnailUrl) {
            return isRequired(value) ? 'ファイルを選択してください' : '';
        }
        return '';
    },
    isFileValid(),
    isAllowAcceptTypeFile('image/*', '画像ファイルを選択してください'),
    isAllowMegaSizeFile(10, '10MB以下のファイルを選択してください'),
];
export const validateArtifactsDescription = [
    isRequiredText('プロジェクト事例の成果物を入力してください'),
    strMax(500, 'プロジェクト事例の成果物は500文字以内で入力してください'),
];
export const validatePeriod = [
    isRequiredText('プロジェクト事例の実施期間を入力してください'),
    isNumber('正の整数を入力してください'),
    isNumberWithinRange(1, 99, 'プロジェクト事例の実施期間は1週間から99週間の間で設定してください'),
];
export const validateRegion = [
    (values) => (values || []).every((v) => !v)
        ? '対応可能エリアを1つ以上選択してください'
        : '',
    isRequiredText('対応可能エリアを1つ以上選択してください'),
];
export const validateRegionOther = [requiredWithRegionOther];
export const validateFaqQuestion = [
    isRequiredWithObj('よくある質問の質問内容を入力してください', 'answer'),
    strMax(100, 'よくある質問の質問内容は100文字以内で入力してください'),
];
export const validateFaqAnswer = [
    isRequiredWithObj('よくある質問の回答を入力してください', 'question'),
    strMax(500, 'よくある質問の回答は500文字以内で入力してください'),
];
export const validateCaution = [
    strMax(500, '注意事項は500文字以内で入力してください'),
];
